import { SchemaManager } from '@/components/schema/schema-manager'
import { useCaseContext } from '../../CaseContext'

/**
 * Case Schema page (SP-384, slice 01). Renders the shared schema editor in its
 * case-scoped mode — the `caseId` context turns on the in-use / global-default
 * markers and select-writes-binding. Schema selection for the case lives here.
 */
export default function CaseSchemaPage() {
  const { caseId, caseData } = useCaseContext()
  return <SchemaManager context={{ caseId, caseName: caseData.name }} />
}
